<template>
  <div class="calculator-toolbox-landing">
    <!-- Grid of Tools -->
    <div class="calculator-toolbox-landing__container">
      <div class="calculator-toolbox-landing__grid">
        <!-- Route Cost Report Tool -->
        <div class="calculator-toolbox-landing__card" @click="navigateToRouteCost">
          <div class="calculator-toolbox-landing__card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3 class="calculator-toolbox-landing__card-title">Get Route Cost Report</h3>
          <p class="calculator-toolbox-landing__card-description">
            Calculate transportation costs between any two locations with detailed breakdown by vehicle type and cost categories.
          </p>
          <div class="calculator-toolbox-landing__card-action">
            <span>Start Calculating</span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <!-- Rack Optimization Calculator -->
        <div class="calculator-toolbox-landing__card" @click="navigateToRackOptimization">
          <div class="calculator-toolbox-landing__card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3 class="calculator-toolbox-landing__card-title">Cubic Feet + Rack Optimization</h3>
          <p class="calculator-toolbox-landing__card-description">
            Calculate building volume, usable storage, and optimize rack configuration based on equipment type.
          </p>
          <div class="calculator-toolbox-landing__card-action">
            <span>Start Calculating</span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="calculator-toolbox-landing__card" @click="navigateToDockBottleneck">
          <div class="calculator-toolbox-landing__card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 7v5l3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3 class="calculator-toolbox-landing__card-title">Dock & Yard Bottleneck Calculator</h3>
          <p class="calculator-toolbox-landing__card-description">
            Calculate the financial impact of dock congestion and yard delays on your warehouse operations.
          </p>
          <div class="calculator-toolbox-landing__card-action">
            <span>Calculate Costs</span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <!-- Professional Lease Audit Tool -->
        <div class="calculator-toolbox-landing__card" @click="navigateToLeaseAudit">
          <div class="calculator-toolbox-landing__card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 3v4a1 1 0 0 0 1 1h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="9" y1="9" x2="10" y2="9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <line x1="9" y1="13" x2="15" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <line x1="9" y1="17" x2="15" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <h3 class="calculator-toolbox-landing__card-title">Professional Lease Audit</h3>
          <p class="calculator-toolbox-landing__card-description">
            Upload lease documents for AI-powered analysis with risk assessment and compliance checking.
          </p>
          <div class="calculator-toolbox-landing__card-action">
            <span>Upload Document</span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <!-- Warehouse HVAC Calculator -->
        <div class="calculator-toolbox-landing__card" @click="navigateToHvacCalculator">
          <div class="calculator-toolbox-landing__card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3 class="calculator-toolbox-landing__card-title">Warehouse HVAC Calculator</h3>
          <p class="calculator-toolbox-landing__card-description">
            Estimate annual HVAC energy costs and peak loads for your warehouse. Includes Quick Estimate and Full ASHRAE-based Analysis modes.
          </p>
          <div class="calculator-toolbox-landing__card-action">
            <span>Start Calculating</span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalculatorToolboxLanding',

  methods: {
    navigateToRouteCost() {
      // Navigate to the route cost report page
      window.location.href = '/route-cost-report';
    },
    
    navigateToRackOptimization() {
      // Navigate to the rack optimization calculator page
      window.location.href = '/rack-optimization-calculator';
    },
    
    navigateToLeaseAudit() {
      // Navigate to the lease file upload page
      window.location.href = '/lease-file-upload';
    },
    
    navigateToDockBottleneck() {
      // Navigate to the dock bottleneck calculator page
      window.location.href = '/dock-bottleneck-calculator';
    },

    navigateToHvacCalculator() {
      window.location.href = '/hvac-calculator';
    }
  }
};
</script>
